import { render } from "./TransactionsPage.vue?vue&type=template&id=4fc8386d&scoped=true"
import script from "./TransactionsPage.vue?vue&type=script&lang=js"
export * from "./TransactionsPage.vue?vue&type=script&lang=js"

import "./TransactionsPage.vue?vue&type=style&index=0&id=4fc8386d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc8386d"]])

export default __exports__